import React from "react"
import "./index.scss"

const ArticleHeaderImage = props => {
  return (
    <div
      className="articleHeaderImageBox"
      data-type='articleHeaderImage'
    >
      <img className="articleHeader_img" src={props.src} alt="header img" />
      <div className="halfCircle" />
    </div>
  )
}

export default ArticleHeaderImage
